// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"a560968a","704":"f0fee644"}[chunkId] + ".chunk.js";
};